<template>
  <div
    v-if="categoryType"
    class="flex flex-row border border-ocean-200 bg-ocean-50 rounded-lg p-3 sm:p-4 sm:items-center space-x-2"
  >
    <fa
      :icon="['fal', categoryIcon]"
      class="text-ocean-700 text-base self-center"
    />
    <span>{{ categoryMessage }}</span>
  </div>
</template>

<script>
import ProductCategoryType from '@/enums/ProductCategoryType';

export default {
  name: 'VetsterProductCategoryBanner',

  computed: {
    categoryIcon() {
      const icons = {
        [ProductCategoryType.Allergies]: 'allergies',
      };

      return icons[this.categoryType];
    },

    categoryMessage() {
      const messages = {
        [ProductCategoryType.Allergies]: this.$t('category.allergies.keep-your-pets-itch'),
      };

      return messages[this.categoryType];
    },

    categoryType() {
      return this.isAllergyCategoryEnabled ? ProductCategoryType.Allergies : null;
    },

    isAllergyCategoryEnabled() {
      // Enabled for US VCPR regions
      return this.$statsig.ready && this.$statsig.checkGate('booking_allergy_questionnaire');
    },
  },
};
</script>
